import Vue from 'vue'
import Vuex from 'vuex'
import localDb from '@/utils/localDb'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localDb.get('TOKEN', ''),
    user: localDb.get('USER'),
    loading: false,
    authCode: localDb.get('authCode', ''),
  },
  mutations: {
    setToken(state, val) {
      localDb.save("TOKEN", val);
      state.token = val;
    },
    setUser(state, val) {
      localDb.save("USER", val);
      state.user = val;
    },
    setAuthoCode(state, val) {
      localDb.save("authCode", val);
      state.authCode = val;
    },
    setLoadingVisible(state, val) {
      state.loading = val;
    }
  },
  actions: {
  },
  modules: {
  }
})
